import { BorderColor } from './types';
import { avatarColors } from './constants';

export function getBorderColorByNftLevel(level: number): BorderColor {
    const levels: { [key: number]: BorderColor } = {
        1: BorderColor.blue,
        2: BorderColor.pink,
        3: BorderColor.violet,
    };

    return levels[level];
}

export function getColorByUserId(userId?: number) {
    return avatarColors[Math.abs((userId || 0) % avatarColors.length)];
}

export function getFirstUpperLetter(str?: string) {
    return typeof str === 'string' ? str.substring(0, 1).toUpperCase() : '';
}
